import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import jojoAccount from '@jojo/account-sdk';
import dotRender from '@/helpers/dotRender';
import { areaCodeResp } from '@/utils/areaCode';
import { addClass } from '@/utils/dom';
import { appendDrawer } from '../Drawer';
export var areaCodeTmp = "\n<div sensors-disable=\"true\" class=\"ui-drawer-order\">\n    <div class=\"areacode-content\">\n      <div class=\"drawer-title\">{{=it.t(\"courseSelection.telephonecode.title\")}}</div>\n      <div class=\"ac-box\">\n        <div class=\"list-box\">\n          <div class=\"list-item-title\">{{=it.t(\"courseSelection.telephonecode.commonly\")}}</div>\n          <div class=\"list\">\n            {{~it.common:value}}\n            <div class=\"list-item\">\n              <div class=\"list-item-box\" data-name=\"item\">\n                <span class=\"li-left\" data-areaname={{=value.areaName}}>{{=value.areaName}}</span>\n                <span class=\"li-right\" data-telephonecode={{=value.telephoneCode}}>+{{=value.telephoneCode}}</span>\n              </div>\n            </div>\n            {{~}}\n          </div>\n        </div>\n        <div class=\"list-box\">\n          <div class=\"list-item-title\">{{=it.t(\"courseSelection.telephonecode.other\")}}</div>\n          <div class=\"list\">\n            {{~it.all:value}}\n            <div class=\"list-item\">\n              <div class=\"list-item-box\" data-name=\"item\">\n                <span class=\"li-left\" data-areaname={{=value.areaName}}>{{=value.areaName}}</span>\n                <span class=\"li-right\" data-telephonecode={{=value.telephoneCode}}>+{{=value.telephoneCode}}</span>\n              </div>\n            </div>\n            {{~}}\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n";

var AreaCode = function () {
  function AreaCode(id, ops) {
    this.ops = {
      code: '+86',
      init: true
    };
    this.$code = null;

    if (ops) {
      this.ops = __assign({
        code: '+86',
        init: true
      }, ops);
    }

    this.render(id);
  }

  AreaCode.prototype.render = function (id) {
    var _this = this;

    var box = typeof id === 'string' ? document.getElementById(id.replace(/^#/, '')) : id;

    if (box) {
      var span = document.createElement('span');
      var iItem = document.createElement('i');
      addClass(span, 'national-code');
      addClass(iItem, 'ui-icon ui-icon-down1');
      addClass(box, 'national-box');
      span.innerText = this.ops.code || '+86';
      box.appendChild(span);
      box.appendChild(iItem);
      box.addEventListener('click', function (ev) {
        _this.show();

        var onClick = _this.ops.onClick;

        if (typeof onClick === 'function') {
          onClick(ev);
        }
      }, false);
      this.$code = span;
    }
  };

  AreaCode.prototype.getCode = function () {
    return this.ops.code;
  };

  AreaCode.prototype.show = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, onClose, onChange, areaCodeList, jojoAccountAreaCodeData, areaCodeData;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.ops, onClose = _a.onClose, onChange = _a.onChange;
            return [4
            /*yield*/
            , jojoAccount.getNationalCodeList()];

          case 1:
            areaCodeList = _b.sent();
            jojoAccountAreaCodeData = ((areaCodeList === null || areaCodeList === void 0 ? void 0 : areaCodeList.data) || []).map(function (item) {
              return __assign(__assign({}, item), {
                telephoneCode: item.nationalCode,
                areaName: item.nationalName
              });
            });
            areaCodeData = jojoAccountAreaCodeData.length ? {
              // 大陆86、澳门853、香港852、台湾886是常用
              common: jojoAccountAreaCodeData.filter(function (item) {
                return ['86', '853', '852', '886'].includes(item.telephoneCode);
              }),
              all: jojoAccountAreaCodeData
            } : areaCodeResp;
            appendDrawer({
              id: 'j-area-code',
              onClose: onClose,
              onMount: function onMount($content) {
                $content.addEventListener('click', function (e) {
                  var _a, _b, _c, _d, _e;

                  e.stopPropagation();
                  var event = e || window.event;
                  var target = event.target || event.srcElement; // 判断是否匹配目标元素

                  if (target && ((target === null || target === void 0 ? void 0 : target.dataset.name) === 'item' || (target === null || target === void 0 ? void 0 : target.dataset.areaname) || (target === null || target === void 0 ? void 0 : target.dataset.telephonecode))) {
                    var rightText_1 = (_b = (_a = target === null || target === void 0 ? void 0 : target.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector('.li-right')) === null || _b === void 0 ? void 0 : _b.innerText;
                    _this.ops.code = rightText_1; // 修改dom

                    if (_this.$code) {
                      _this.$code.innerHTML = rightText_1;
                    }

                    document.body.removeChild($content);

                    if (typeof onChange === 'function') {
                      var leftText_1 = (_d = (_c = target === null || target === void 0 ? void 0 : target.parentNode) === null || _c === void 0 ? void 0 : _c.querySelector('.li-left')) === null || _d === void 0 ? void 0 : _d.innerText;
                      var chooseItem = (_e = areaCodeData.all) === null || _e === void 0 ? void 0 : _e.find(function (item) {
                        return "".concat(item.areaName, "+").concat(item.telephoneCode) === "".concat(leftText_1).concat(rightText_1);
                      });
                      onChange(rightText_1, {
                        areaInfo: chooseItem
                      });
                    }
                  }
                }, false);
              },
              // 渲染支付弹窗结构
              content: dotRender(areaCodeTmp, __assign({}, this.ops.areaCodeData || areaCodeData))
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return AreaCode;
}();

export default AreaCode;